<template class="has-background-black">
  <section class="bg padding-top" :style="{ backgroundImage: 'url(' + headerImage + ')' }">
    <!-- Hero content: will be in the middle -->
    <div class="hero-body">
      <div class="container has-text-centered">
        <h1 class="title is-1 has-text-weight-bold is-uppercase">
          <!-- <p class="subtitle code">
            Welcome&nbsp;to
            <br />
          </p>-->
          <img class="logo" src="@/assets/logo.svg" width="700px" />
          <!-- <span style="text-shadow: 2px 2px #000000;">Knockout&nbsp;</span>
          <span class="highlighter">Fight Club</span>-->
        </h1>
        <h2 class="subtitle is-1 secondary-title">India's No.1 MMA School</h2>
        <b-button
          class="button is-primary has-text-weight-semibold cta is-uppercase primary-btn"
          tag="a"
          size="is-medium"
          @click="isComponentModalActive = true"
        >&nbsp; Book a Free Trial</b-button>
        <SecondaryBtn />
      </div>
    </div>
    <div class="hero-foot">
      <nav class="navbar is-fixed-bottom hero hero-bottom is-transparent" style="padding: 0.2rem">
        <a class="container button is-rounded has-background-black" href="tel:+91-9810021011">
          <div class="navbar-item">
            <i class="fa fa-phone has-text-light fa-flip-horizontal"></i>
            <span
              class="has-text-weight-bold has-text-grey-lighter is-uppercase"
            >&nbsp;Book a Trial on Call:&nbsp;</span>
            <span class="has-text-weight-bold hover has-text-link">9810021011</span>
          </div>
        </a>
      </nav>
      <section class="section background-black">
        <div class="columns has-text-centered has-text-light">
          <div class="column column-pad">
            <h1 class="title has-text-white has-text-weight-bold is-uppercase">Fighting</h1>
            <p>We teach various forms of Martial Arts - Boxing, Kickboxing, Krav Maga, Muay Thai, Brazilian Jiu-Jitsu, Karate, Wrestling and cater to people of all ages and skill levels, from complete beginners to international level athletes</p>
          </div>
          <div class="column column-pad">
            <h1 class="title has-text-white has-text-weight-bold is-uppercase">Personal Development</h1>
            <p>We specialise in functional fitness which works on your body holistically, improving all aspects of fitness such as Strength, Motor-Body Coordination, stamina, flexibility. Our sports-based strength and conditioning programs not only get you in killer shape</p>
          </div>
          <div class="column column-pad">
            <h1 class="title has-text-white has-text-weight-bold is-uppercase">Fitness</h1>
            <p>Martial Arts develops you physically, mentally and spiritually. Knockout's training style and culture focuses on retaining the old school principles of Martial Arts which aim at transforming you in all areas of life. You will see yourself become more dynamic, fearless, and develop a high achievers attitude</p>
          </div>
        </div>
      </section>
    </div>
    <!-- News Coverage -->

    <!-- Modal Window. Visible on-click -->
    <b-modal
      :active.sync="isComponentModalActive"
      has-modal-card
      trap-focus
      aria-role="dialog"
      aria-modal
    >
      <BookTrialModal v-bind="formProps"></BookTrialModal>
    </b-modal>
  </section>
</template>

<script>
// import PrimaryBtn from "./Primary-btn.vue";
import SecondaryBtn from "./Secondary-btn.vue";
import BookTrialModal from "@/components/BookTrial/BookTrial-modal.vue";

export default {
  data() {
    return {
      headerImage: require("@/assets/header.jpg"),
      isComponentModalActive: false,
      formProps: {
        email: "",
        password: ""
      }
    };
  },
  components: {
    // PrimaryBtn,
    SecondaryBtn,
    BookTrialModal
  }
};
</script>

<style lang="scss" scoped>
.code {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  font-weight: 200 !important;
  font-size: 18px;
  text-shadow: 1px 1px #131313;
}
.secondary-title {
  font-size: 1.5rem !important;
  padding-top: 1rem;
  font-weight: 200;
}

.background-black {
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) 100%,
    rgba(19, 19, 19, 1) 47%,
    rgba(38, 38, 38, 1) 0%
  );
}

.column-pad {
  padding: 3em;
}

.bg {
  // background-image: url("../assets/header.jpg");
  position: relative;
  background-position: center center;
}
.main-title {
  font-size: 6rem;
}
.cta {
  padding: 1.5em !important;
  margin: 0.5em;
  text-shadow: 2px 2px #ce020a;
}

.button {
  border-radius: 0;
}

.secondary-btn-border {
  border-bottom: 2px solid #ff000a !important;
  border-top: transparent;
}
</style>
